import routerOptions0 from "/tmp/workspace/staging/ghl-membership-frontend-clientportal/node_modules/.pnpm/nuxt@3.21.2_@emnapi+core@1.11.3_@emnapi+runtime@1.11.3_@types+node@24.13.3_@vue+compiler-sfc@_ruxtxw2pimbzbcxlqhpo533bka/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}